export const TASK_LIST_DISPLAY_NAME = 'To-do list';

// Content properties
export const SHOW_TITLE_PROPERTY = 'showTitle';
export const TITLE_SUGGESTION_ACK_PROPERTY = 'titleSuggestionAck';
export const DELETE_TASKS_SUGGESTION_DISMISSED_PROPERTY = 'deleteTasksDismissed';
